import {
    RFile,
    FileToUpload,
    StrapiUploadFileField,
    StrapiUploadFileRef,
    UploadType,
    UploadedMedia
} from '../../types/Upload';

export const makeFileInfo = (upload: FileToUpload): Partial<RFile> => ({
    name: upload.name,
    caption: upload.source ?? '',
    alternativeText: upload.description ?? ''
});

export const prepareFormDataForUpload = (
    files: FileToUpload[],
    strapiInfo: {
        parentId: string;
        collectionRef: StrapiUploadFileRef;
        fieldType: StrapiUploadFileField;
    }
): FormData[] =>
    files.map((file) => {
        let formData = new FormData();

        formData.append('files', file.data);
        formData.append('ref', strapiInfo.collectionRef);
        formData.append('refId', strapiInfo.parentId.toString());
        formData.append('field', strapiInfo.fieldType);
        formData.append('fileInfo', JSON.stringify(makeFileInfo(file)));
        return formData;
    });

export const prepareFormDataForUpdate = (
    file: UploadedMedia<UploadType.Image | UploadType.Document>,
    strapiInfo: {
        parentId: string;
        collectionRef: StrapiUploadFileRef;
        fieldType: StrapiUploadFileField;
    }
): FormData => {
    let formData = new FormData();

    formData.append('ref', strapiInfo.collectionRef);
    formData.append('refId', strapiInfo.parentId.toString());
    formData.append('field', strapiInfo.fieldType);
    formData.append(
        'fileInfo',
        JSON.stringify({
            name: file.name,
            caption: file.source ?? '',
            alternativeText: file.description ?? ''
        })
    );
    return formData;
};
